var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      link: { path: `/billboard/${_vm.booking.id}` },
      booking: _vm.booking,
    },
    scopedSlots: _vm._u(
      [
        _vm.$userIsAdmin && _vm.bookingHasTalentResponses
          ? {
              key: "bids",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "list-item__bids",
                      attrs: { "data-test-id": "numberBids" },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.booking.talent_response_count) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "categories",
          fn: function () {
            return [
              _vm.booking.opportunities.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    _vm._l(_vm.booking.opportunities, function (opp) {
                      return _c(
                        "span",
                        { key: opp.id, staticClass: "label label-info" },
                        [_vm._v(_vm._s(opp.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "status",
          fn: function () {
            return [
              _vm.booking.urgent
                ? _c("div", { staticClass: "spacer-b-2" }, [
                    _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "applications",
          fn: function () {
            return [
              _vm.$userIsTalent || _vm.$userIsManager
                ? [
                    _vm.talentHasAppliedForBooking
                      ? _c(
                          "span",
                          {
                            staticClass: "label label-success",
                            attrs: { "data-test-id": "hasApplied" },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$declineModuleEnabled
                                    ? _vm.$t("Applied")
                                    : "Accepted"
                                ) +
                                "\n        "
                            ),
                            _vm.$userIsManager
                              ? [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.talentAppliedForBooking) +
                                      ")"
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm.talentHasDeclinedBooking
                      ? _c(
                          "span",
                          {
                            staticClass: "label label-danger",
                            attrs: { "data-test-id": "hasDeclined" },
                          },
                          [
                            _vm._v("\n        Declined\n        "),
                            _vm.$userIsManager
                              ? [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.talentDeclinedBooking) +
                                      ")"
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                : _vm.talentHasMixedResponse
                ? _c("div", { staticClass: "list-item__status" }, [
                    _c(
                      "span",
                      {
                        staticClass: "label label-success",
                        attrs: { "data-test-id": "hasApplied" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$declineModuleEnabled
                              ? _vm.$t("Applied")
                              : "Accepted"
                          ) +
                            " (" +
                            _vm._s(_vm.talentAppliedForBooking) +
                            ")"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "label label-danger",
                        attrs: { "data-test-id": "hasDeclined" },
                      },
                      [
                        _vm._v(
                          "Declined (" + _vm._s(_vm.talentDeclinedBooking) + ")"
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  _vm.$userIsTalent || _vm.$userIsManager
                    ? _c(
                        "span",
                        { attrs: { "data-test-id": "budgetPrice" } },
                        [
                          _vm.booking.local_currency
                            ? [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("currency")(
                                          _vm.booking
                                            .local_currency_budget_per_star_as_user_rate,
                                          _vm.booking.local_currency
                                        )
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("currency")(
                                          _vm.booking
                                            .budget_per_star_as_user_rate,
                                          _vm.booking.currency
                                        )
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ],
                        ],
                        2
                      )
                    : _c(
                        "span",
                        { attrs: { "data-test-id": "budgetPrice" } },
                        [
                          _vm.booking.local_currency
                            ? [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("currency")(
                                          _vm.booking
                                            .local_currency_budget_per_star,
                                          _vm.booking.local_currency
                                        )
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("currency")(
                                          _vm.booking.budget_per_star,
                                          _vm.booking.currency
                                        )
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ],
                        ],
                        2
                      ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }